/*
	rule
	money: 金额
	zpNum: 正整数 Z+，Zplus
	zNum: 整数
	znNum: 负整数
*/
const moneyRegexp = /^(([1-9]\d*)|\d)(\.\d{1,3})?$/;
// export const zpNumRegexp = /^[0-9]*[1-9][0-9]*$/;
const zpNumRegexp = /^[1-9][0-9]*$/; // 不能以零开头的正整数，注意正整数不为零
const pIntRegexp = /^\d+$/; // 非负整数（正整数 + 0）
// "^//d+$"; //非负整数（正整数 + 0）
// "^[0-9]*[1-9][0-9]*$"; //正整数
// "^((-//d+)|(0+))$"; //非正整数（负整数 + 0）
// "^-[0-9]*[1-9][0-9]*$"; //负整数
// "^-?//d+$"; //整数
// "^//d+(//.//d+)?$"; //非负浮点数（正浮点数 + 0）
// "^(([0-9]+//.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*//.[0-9]+)|([0-9]*[1-9][0-9]*))$"; //正浮点数
// "^((-//d+(//.//d+)?)|(0+(//.0+)?))$"; //非正浮点数（负浮点数 + 0）
// "^(-(([0-9]+//.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*//.[0-9]+)|([0-9]*[1-9][0-9]*)))$"; //负浮点数
// "^(-?//d+)(//.//d+)?$"; //浮点数
const phoneRegexp = /^1[3-9]\d{9}$/; // 电话号码
const idCardRegexp = /(^d{15}$)|(^d{17}([0-9]|X)$)/; // 身份证正则
// 提取信息中的网络链接:(h|H)(r|R)(e|E)(f|F) *= *('|")?(w|\|/|.)+('|"| *|>)?
// 提取信息中的邮件地址:w+([-+.]w+)*@w+([-.]w+)*.w+([-.]w+)*
// 提取信息中的图片链接:(s|S)(r|R)(c|C) *= *('|")?(w|\|/|.)+('|"| *|>)?
// 提取信息中的IP地址:(d+).(d+).(d+).(d+)
// 提取信息中的中国电话号码（包括移动和固定电话）:((d{3,4})|d{3,4}-|s)?d{7,14}
// 提取信息中的中国邮政编码:[1-9]{1}(d+){5}
// 提取信息中的中国身份证号码:d{18}|d{15}
// 提取信息中的整数：d+
// 提取信息中的浮点数（即小数）：(-?d*).?d+
// 提取信息中的任何数字 ：(-?d*)(.d+)?
// 提取信息中的中文字符串：[u4e00-u9fa5]*
// 提取信息中的双字节字符串 (汉字)：[^x00-xff]*
export { moneyRegexp, zpNumRegexp, pIntRegexp, phoneRegexp, idCardRegexp };
